import blue1 from '../images/confetti_25/blue_confetti_1.png';
import blue2 from '../images/confetti_25/blue_confetti_2.png';
import green1 from '../images/confetti_25/green_confetti_1.png';
import green2 from '../images/confetti_25/green_confetti_2.png';
import red1 from '../images/confetti_25/red_confetti_1.png';
import red2 from '../images/confetti_25/red_confetti_2.png';
import violet1 from '../images/confetti_25/violet_confetti_1.png';
import violet2 from '../images/confetti_25/violet_confetti_2.png';
import yellow1 from '../images/confetti_25/yellow_confetti_1.png';
import yellow2 from '../images/confetti_25/yellow_confetti_2.png';

// export default {
//   id: "tsparticles_confetti_25",
//     options: {
//     "fullScreen": {
//       "zIndex": 1
//     },
//     "emitters": {
//       "position": {
//         "x": 50,
//         "y": 100
//       },
//       "rate": {
//         "quantity": 5,
//         "delay": 0.15
//       }
//     },
//     "particles": {
//       "color": {
//         "value": [
//           "#1E00FF",
//           "#FF0061",
//           "#E1FF00",
//           "#00FF9E"
//         ]
//       },
//       "move": {
//         "decay": 0.05,
//         "direction": "top",
//         "enable": true,
//         "gravity": {
//           "enable": true
//         },
//         "outModes": {
//           "top": "none",
//           "default": "destroy"
//         },
//         "speed": {
//           "min": 50,
//           "max": 100
//         }
//       },
//       "number": {
//         "value": 0
//       },
//       "opacity": {
//         "value": 1
//       },
//       "rotate": {
//         "value": {
//           "min": 0,
//           "max": 360
//         },
//         "direction": "random",
//         "animation": {
//           "enable": true,
//           "speed": 30
//         }
//       },
//       "tilt": {
//         "direction": "random",
//         "enable": true,
//         "value": {
//           "min": 0,
//           "max": 360
//         },
//         "animation": {
//           "enable": true,
//           "speed": 30
//         }
//       },
//       "size": {
//         "value": 3,
//         "animation": {
//           "enable": true,
//           "startValue": "min",
//           "count": 1,
//           "speed": 16,
//           "sync": true
//         }
//       },
//       "roll": {
//         "darken": {
//           "enable": true,
//           "value": 25
//         },
//         "enlighten": {
//           "enable": true,
//           "value": 25
//         },
//         "enable": true,
//         "speed": {
//           "min": 5,
//           "max": 15
//         }
//       },
//       "wobble": {
//         "distance": 30,
//         "enable": true,
//         "speed": {
//           "min": -7,
//           "max": 7
//         }
//       },
//       "shape": {
//         "type": "image",
//         "options": {
//           "image": [
//             {
//               "src": blue1,
//               "width": 32,
//               "height": 32,
//               "particles": {
//                 "size": {
//                   "value": 16
//                 }
//               }
//             },
//             {
//               "src": blue2,
//               "width": 32,
//               "height": 32,
//               "particles": {
//                 "size": {
//                   "value": 16
//                 }
//               }
//             },
//             {
//               "src": green1,
//               "width": 32,
//               "height": 32,
//               "particles": {
//                 "size": {
//                   "value": 16
//                 }
//               }
//             },
//             {
//               "src": green2,
//               "width": 32,
//               "height": 32,
//               "particles": {
//                 "size": {
//                   "value": 16
//                 }
//               }
//             },
//             {
//               "src": red1,
//               "width": 32,
//               "height": 32,
//               "particles": {
//                 "size": {
//                   "value": 16
//                 }
//               }
//             },
//             {
//               "src": red2,
//               "width": 32,
//               "height": 32,
//               "particles": {
//                 "size": {
//                   "value": 16
//                 }
//               }
//             },
//             {
//               "src": violet1,
//               "width": 32,
//               "height": 32,
//               "particles": {
//                 "size": {
//                   "value": 16
//                 }
//               }
//             },
//             {
//               "src": violet2,
//               "width": 32,
//               "height": 32,
//               "particles": {
//                 "size": {
//                   "value": 16
//                 }
//               }
//             },
//             {
//               "src": yellow1,
//               "width": 32,
//               "height": 32,
//               "particles": {
//                 "size": {
//                   "value": 16
//                 }
//               }
//             },
//             {
//               "src": yellow2,
//               "width": 32,
//               "height": 32,
//               "particles": {
//                 "size": {
//                   "value": 16
//                 }
//               }
//             },
//           ]
//         }
//       }
//     },
//     "responsive": [
//       {
//         "maxWidth": 1024,
//         "options": {
//           "particles": {
//             "move": {
//               "speed": {
//                 "min": 33,
//                 "max": 66
//               }
//             }
//           }
//         }
//       }
//     ]
//   }
// }

export default {
  id: "tsparticles",
  options: {
  "fullScreen": {
    "zIndex": 1
  },
  "emitters": [
    {
      "position": {
        "x": 0,
        "y": 30
      },
      "rate": {
        "quantity": 1,
        "delay": 0.15
      },
      "particles": {
        "move": {
          "direction": "top-right",
          "outModes": {
            "top": "none",
            "left": "none",
            "default": "destroy"
          }
        }
      }
    },
    {
      "position": {
        "x": 100,
        "y": 30
      },
      "rate": {
        "quantity": 1,
        "delay": 0.15
      },
      "particles": {
        "move": {
          "direction": "top-left",
          "outModes": {
            "top": "none",
            "right": "none",
            "default": "destroy"
          }
        }
      }
    }
  ],
  "particles": {
    "color": {
      "value": [
        "#ffffff",
        "#FF0000"
      ]
    },
    "move": {
      "decay": 0.05,
      "direction": "top",
      "enable": true,
      "gravity": {
        "enable": true
      },
      "outModes": {
        "top": "none",
        "default": "destroy"
      },
      "speed": {
        "min": 10,
        "max": 50
      }
    },
    "number": {
      "value": 0
    },
    "opacity": {
      "value": 1
    },
    "rotate": {
      "value": {
        "min": 0,
        "max": 360
      },
      "direction": "random",
      "animation": {
        "enable": true,
        "speed": 30
      }
    },
    "tilt": {
      "direction": "random",
      "enable": true,
      "value": {
        "min": 0,
        "max": 360
      },
      "animation": {
        "enable": true,
        "speed": 30
      }
    },
    "size": {
      "value": {
        "min": 0,
        "max": 2
      },
      "animation": {
        "enable": true,
        "startValue": "min",
        "count": 1,
        "speed": 16,
        "sync": true
      }
    },
    "roll": {
      "darken": {
        "enable": true,
        "value": 25
      },
      "enable": true,
      "speed": {
        "min": 5,
        "max": 15
      }
    },
    "wobble": {
      "distance": 30,
      "enable": true,
      "speed": {
        "min": -7,
        "max": 7
      }
    },
    "shape": {
      "type": "image",
      "options": {
        "image": [
            {
              "src": blue1,
              "width": 32,
              "height": 32,
              "particles": {
                "size": {
                  "value": 16
                }
              }
            },
            {
              "src": blue2,
              "width": 32,
              "height": 32,
              "particles": {
                "size": {
                  "value": 16
                }
              }
            },
            {
              "src": green1,
              "width": 32,
              "height": 32,
              "particles": {
                "size": {
                  "value": 16
                }
              }
            },
            {
              "src": green2,
              "width": 32,
              "height": 32,
              "particles": {
                "size": {
                  "value": 16
                }
              }
            },
            {
              "src": red1,
              "width": 32,
              "height": 32,
              "particles": {
                "size": {
                  "value": 16
                }
              }
            },
            {
              "src": red2,
              "width": 32,
              "height": 32,
              "particles": {
                "size": {
                  "value": 16
                }
              }
            },
            {
              "src": violet1,
              "width": 32,
              "height": 32,
              "particles": {
                "size": {
                  "value": 16
                }
              }
            },
            {
              "src": violet2,
              "width": 32,
              "height": 32,
              "particles": {
                "size": {
                  "value": 16
                }
              }
            },
            {
              "src": yellow1,
              "width": 32,
              "height": 32,
              "particles": {
                "size": {
                  "value": 16
                }
              }
            },
            {
              "src": yellow2,
              "width": 32,
              "height": 32,
              "particles": {
                "size": {
                  "value": 16
                }
              }
            },
          ]
      }
    }
  }
}
}